import React, { Component } from 'react';
import authService from './api-authorization/AuthorizeService';

export class Home extends Component {
    displayName = Home.name
    constructor(props) {
        super(props);
        this.getCookie = this.getCookie.bind(this);
        this.setPassword = this.setPassword.bind(this);
        this.setCookie = this.setCookie.bind(this);
        this.login = this.login.bind(this);
        this.logout = this.logout.bind(this);

        this.state = {
            isAuthenticated: false,
            password: ""
        }
    }
    setPassword(str) {
        this.setState({ password: str });
    }
    login() {
        this.setCookie("liferu", this.state.password, 30);
        var localCookie = this.getCookie('liferu');
        if (localCookie != "statanlylife2021") {
            this.setState({ isAuthenticated: false });
        }
        else {
            this.setState({ isAuthenticated: true });
        } 
        window.location.reload(false);
    }
    logout() {
        this.setCookie("liferu", "", 30);
        window.location.reload(false);
        //var localCookie = this.getCookie('liferu');
        //if (localCookie != "statanlylife2021") {
        //    this.setState({ isAuthenticated: false });
        //}
        //else {
        //    this.setState({ isAuthenticated: true });
        //}
        

    }
    getCookie(name) {
        var nameEQ = name + "=";
        var ca = document.cookie.split(';');
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
        }
        return null;
    }
    setCookie(name, value, days) {
        var expires = "";
        if (days) {
            var date = new Date();
            date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
            expires = "; expires=" + date.toUTCString();
        }
        document.cookie = name + "=" + (value || "") + expires + "; path=/";
    }
    componentWillMount() {
        var localCookie = this.getCookie('liferu');
        if (localCookie != "statanlylife2021") {
            this.setState({ isAuthenticated: false });
        }
        else {
            this.setState({ isAuthenticated: true });
        }     
    }
    render() {
        var result = this.state.isAuthenticated ? <div>
            <h1>Прогнозная система характеристик публикаций</h1>
            <p>«Аналитическая система прогнозирования поведенческих характеристик публикаций» с использованием технологий
                машинного обучения и анализа данных с целью оптимизации стратегии показа медиа контента
            </p>          
            <p>Содержание:</p>
            <div className="row">
                <div className="col-md-6">
                    <ul>
                        <li><a href='/second'>BERT</a></li>
                        <li><a href='/third'>Документация</a></li>
                        <li><a href='#' onClick={this.logout}>Выйти</a></li>
                    </ul>
                    <p>Техническое задание</p>
                    <ul>
                        <li><strong>ПРЕДПОСЫЛКИ</strong>. «Life.ru» — российское информационное интернет-издание и телеканал. Следуя важнейшему
                            приоритету компании — постоянному улучшению качества сервиса и оптимизации ресурсов, компания постоянно использует возможность современных технологий
                            анализа данных и искусственного интеллекта с целью улучшения качества и оптимизации различных процессов компании.
                             </li>
                        <li><strong>ЦЕЛИ ПРОЕКТА</strong>.
                            Создание программного обеспечения «Аналитическая система прогнозирования поведенческих характеристик публикаций» с использованием технологий машинного обучения и анализа данных
                             </li>
                        <li><strong>СОДЕРЖЕНИЕ РАБОТ</strong>.
                            В рамках данного проекта требуется разработать прогнозные алгоритмы, а также определить набор признаков, которые влияют на поведенческие характеристики. В частности, прогнозы по количеству визитов, источникам трафика и т.д. Алгоритм должен принимать на вход описательные характеристики публикации (заголовок статьи, объем статьи и т.д.), а на выходе предоставлять прогнозы по количеству визитов и источнику трафика. На первом этапе, в качестве входных параметром используется только заголовок статьи.
                            Форматы выходных данных, а также API согласовывается в процессе разработки.
                            В рамках проекта подразумевается применение различных методов и архитектур для моделей, решающих поставленную задачу, а также использование разметки данных с последующим обогащением информации.
                            По окончанию проекта Заказчику будет предоставлен весь программный код, документация, отчет о проделанной работе, продемонстрирована работа алгоритмов и развернут сервис в инфраструктуре заказчика.
                            </li>
                    </ul>
                </div>
                <div className="col-md-6">
                    <img src="/assets/img/NT.jpg" style={{ width: "100%" }}></img>
                </div>
            </div>
        </div> :
            <div style={{ marginTop: "200px" }}>
                <div className="row form-group" >
                    <div className="col-md-2">
                        <h4>Пароль: </h4>
                    </div>
                    <div className="col-md-4">
                        <input placeholder="" className="form-control" type="password" value={this.state.password} onChange={(e) => this.setPassword(e.target.value)}></input>
                    </div>
                    <div className="col-md-2">
                        <button className="button" onClick={this.login} >Войти</button>
                    </div>
                </div>            
            </div>
        return (
            <div>{result}</div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/Home.js